import './index.scss';
import PropTypes from 'prop-types';
import React from 'react';
import Map from 'views/ui/map';

class TourPageMap extends React.Component {
  static displayName = 'TourPage-Map';

  static propTypes = {
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  };

  render() {
    var markerOptions = {
      title: this.props.name,
    };

    return (
      <div className="component-placeholder TourPage-Map" id="map">
        <Map
          latitude={this.props.latitude}
          longitude={this.props.longitude}
          markerOptions={markerOptions}
        />
      </div>
    );
  }
}

export default TourPageMap;
